export default __webpack_public_path__ + "static/media/mariekezwemKlein.cd039e7b.jpg";